import React from "react";
import { motion } from "framer-motion";

// Fade + rise on scroll into view
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line-by-line word reveal for headings
export const MaskedHeading = ({ text, className = "", delay = 0, once = true, onMount = false }) => {
  const words = text.split(" ");
  const container = {
    hidden: {},
    show: { transition: { delayChildren: delay, staggerChildren: 0.07 } },
  };
  const child = {
    hidden: { y: "110%" },
    show: { y: "0%", transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
  };
  return (
    <motion.span
      className={className}
      aria-label={text}
      variants={container}
      initial="hidden"
      {...(onMount ? { animate: "show" } : { whileInView: "show", viewport: { once, margin: "-40px" } })}
    >
      {words.map((word, i) => (
        <span key={i} className="inline-block overflow-hidden align-bottom" style={{ paddingBottom: "0.08em", marginRight: "0.22em" }}>
          <motion.span className="inline-block" variants={child}>
            {word}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const SectionLabel = ({ children }) => (
  <Reveal>
    <div className="flex items-center gap-4 mb-6">
      <span className="h-px w-10 bg-brand" />
      <span className="font-display text-xs md:text-sm tracking-[0.3em] uppercase text-brand">
        {children}
      </span>
    </div>
  </Reveal>
);
